document.addEventListener('DOMContentLoaded', () => {
    if(document.querySelector('#home-button')){
        document.querySelector('#home-button').addEventListener('click', () => {
            window.location = '/';
        });
    }
});
